export default [
  {
    path: '/documents_storage',
    component: () => import('@/views/documents/DocumentsStorage'),
    meta: { title: '单证入库' }
  },
  {
    path: '/documents_dispatch',
    component: () => import('@/views/documents/DocumentsDispatch'),
    children: [
      {
        path: '',
        component: () => import('@/views/documents/DocumentsDispatchList'),
        meta: { title: '单证记录列表' }
      },
      {
        path: '/documents_dispatch/operation',
        component: () => import('@/views/documents/DocumentsDispatchOperation'),
        meta: { title: '单证发放' }
      }
    ]
  },
  {
    path: '/documents_recycling',
    component: () => import('@/views/documents/DocumentsRecycling'),
    meta: { title: '单证回交/回收' }
  }
]
